import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { GroupBill } from './group-bill.model';
import * as GroupBillActions from './group-bill.actions';

export const groupBillsFeatureKey = 'groupBills';

export interface State extends EntityState<GroupBill> {
  // additional entities state properties
}

export const adapter: EntityAdapter<GroupBill> = createEntityAdapter<GroupBill>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(GroupBillActions.addGroupBill,
    (state, action) => adapter.addOne(action.groupBill, state)
  ),
  on(GroupBillActions.upsertGroupBill,
    (state, action) => adapter.upsertOne(action.groupBill, state)
  ),
  on(GroupBillActions.addGroupBills,
    (state, action) => adapter.addMany(action.groupBills, state)
  ),
  on(GroupBillActions.upsertGroupBills,
    (state, action) => adapter.upsertMany(action.groupBills, state)
  ),
  on(GroupBillActions.updateGroupBill,
    (state, action) => adapter.updateOne(action.groupBill, state)
  ),
  on(GroupBillActions.updateGroupBills,
    (state, action) => adapter.updateMany(action.groupBills, state)
  ),
  on(GroupBillActions.deleteGroupBill,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(GroupBillActions.deleteGroupBills,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(GroupBillActions.loadGroupBills,
    (state, action) => adapter.setAll(action.groupBills, state)
  ),
  on(GroupBillActions.clearGroupBills,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
